import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PUT_AWAY_STATUS } from 'domains/merchant-product-variant/constants'

const propTypes = {
  putAwayStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product Variant `put_away_status`.
 * It maps `put_away_status` to certain style and pass to `StatusBadge`.
 * @param {string} putAwayStatus
 */
const MerchantProductVariantPutAwayStatusBadge = ({ putAwayStatus }) => {

  const colorMap = {
    [PUT_AWAY_STATUS.PENDING]   : 'warning',
    [PUT_AWAY_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[putAwayStatus] || 'default'

  return <StatusBadge color={ color } label={ putAwayStatus } />
}

MerchantProductVariantPutAwayStatusBadge.propTypes = propTypes

export default MerchantProductVariantPutAwayStatusBadge
